import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';

export interface AccordionBadgeConfig {
  label: string;
  textColor: string;
  icon: string;
  bgColor: string;
  status?: boolean;
}

@Component({
  selector: 'gatewee-accordion',
  templateUrl: './gatewee-accordion.component.html',
  styleUrls: ['./gatewee-accordion.component.css'],
  standalone: false,
})
export class GateweeAccordionComponent implements OnChanges {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() data: any = [];
  @Input() open = false;
  @Input() title = '';
  @Input() subtitle = '';
  @Input() isNew = false;
  @Input() configBadge: AccordionBadgeConfig = {
    label: 'Status',
    textColor: '#008236',
    icon: '@tui.check-circle',
    bgColor: '#F0FDF4',
  };

  @Output() delete = new EventEmitter<void>();
  @Output() toggle = new EventEmitter<boolean>();

  accordionOpen = this.open;

  toggleAccordion() {
    this.accordionOpen = !this.accordionOpen;
    this.toggle.emit(this.accordionOpen);
  }

  ngOnChanges() {
    this.accordionOpen = this.open;
  }

  emitDelete(event: MouseEvent): void {
    event.stopPropagation();
    this.delete.emit();
  }

  get badgeLabel() {
    return this.configBadge.label;
  }

  get badgeTextColor() {
    return this.configBadge.textColor;
  }

  get badgeIcon() {
    return this.configBadge.icon;
  }

  get badgeBgColor() {
    return this.configBadge.bgColor;
  }
}
